module.exports = __webpack_public_path__ + "officialStatic/img/ap-detailList12.8bb1cc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/detail/ap-detailList12.png
// module id = Hdrk
// module chunks = 0